export const ACTION = {
    FETCH_SEASON_DATA: 'FETCH_SEASON_DATA',
    RESET_SEASON_DATA: 'RESET_SEASON_DATA',
    FETCH_EPISODE_DETAILS: 'FETCH_EPISODE_DETAILS',
    SEARCH_EPISODE_PI: 'SEARCH_EPISODE_PI',
    FETCH_SEASON_DATA_PAGINATION: 'FETCH_SEASON_DATA_PAGINATION',
    SEARCH_EPISODE_PI_PAGINATION: 'SEARCH_EPISODE_PI_PAGINATION',
}